// Shared wording for archiving (deleting) a client. Shows enough detail that
// staff can tell two similar records apart before they confirm (the Melissa
// Austin / Melissa Austin-Brown mix-up, 2026-10-26).
export function confirmArchiveClient(c: {
  id: string; legal_name?: string | null; email?: string | null; phone?: string | null;
  status?: string | null; created_at?: string | null;
}): boolean {
  const lines = [
    `Delete this client?`,
    ``,
    `Name:   ${c.legal_name || "(unnamed)"}`,
    `Email:  ${c.email || "—"}`,
    `Phone:  ${c.phone || "—"}`,
    `Status: ${(c.status || "—").replace(/_/g, " ")}`,
    c.created_at ? `Added:  ${new Date(c.created_at).toLocaleDateString()}` : "",
    `ID:     ${c.id}`,
    ``,
    `The client is archived, not erased: documents, reports and letters are kept.`,
    `You can undo this from Clients → Status: Archived → Restore.`,
  ];
  return window.confirm(lines.join("\n"));
}
